export const Data = [
    {
      title: "Expand Your Reach",
      detail:
        "Tomedes empowers web publishers and ecommerce sites to extend their marketing and sales reach to additional foreign language markets using localization along with website translation services. We support over 120 languages and 950+ language pairs along with all the adjustments to web pages required for a comprehensive localization effort.",
    
    },
    {
      title: "Improve UX",
      detail:
        "Looking to improve your website’s user experience? Tomedes allows users to have a better experience in their desired languages by fully optimizing your website to be a multilingual one. Your website will be able to accommodate your consumer’s UX needs.",
     
    },
    {
      title: "Generate more leads",
      detail:
        "If you’re looking to acquire more customers, knowing that website translation services by Tomedes makes your website fully multilingual is key. Research shows that 65% of non-native English speakers prefer content in their native tongue, even though they are highly proficient in English--and the more they like your multilingual content, the more likely you are to generate leads.",
   
    },
  
  ];
  
  export const MoreData = [
    {
      title: "Boost Your International SEO",
      detail:
        "SEO and website localization go hand-in-hand, insofar as that they are adapted for the culture and language being targeted. SEO keywords vary from language to language, as well as the look, feel and language of websites. For maximized SEO, search terms and keywords should not be translated word for word, because technical terms vary from one language to another.",
    },
    {
      title: "Engage Better with Local Content    ",
      detail:
        "Some languages with less access to the latest technologies do not yet have equivalent terms for a lot of technical translations, and so the translator must localize the language in such a way that it makes sense to local audiences. You can engage better with local content so that you can better personalize the experience for your audiences, since around 40% of internet users said they will never buy from websites that are not in their native language, according to CSA Research.",
      link: "/french-translation.php",
    },
    {
      title: "Build Your Brand    ",
      detail:
        "With local content and international SEO, you can boost your brand's awareness and build your brand in international locations. You can acquire new customers and gain traction in those countries. According to studies, businesses that invested in translation services such as localization were 1.5 times more likely to observe an increase in revenue. Are you ready for the growth you're about to experience with localization services?",
      link: "/japanese-translation.php",
    },
  ];
  
